// extracted by mini-css-extract-plugin
export default {"container":"CBiNn","grid":"kMOnp","left":"n6qwQ","right":"U9g4d","desktop_header":"MWfa3","mobile_header":"PvwdV"};